import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompletedSubject = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame 188",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 4,
			fill: "#D2EFF9"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "person_check",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_119_12949",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: 9,
				y: 10,
				width: 21,
				height: 20,
				children: /* @__PURE__ */ _jsx("rect", {
					id: "Bounding box",
					x: 9.7998,
					y: 10,
					width: 20,
					height: 20,
					fill: "#D9D9D9"
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_119_12949)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "person_check_2",
					d: "M24.4245 20L21.4661 17.0417L22.6536 15.875L24.4245 17.6458L27.9661 14.1042L29.1328 15.2917L24.4245 20ZM17.2995 20C16.3828 20 15.5981 19.6736 14.9453 19.0208C14.2925 18.3681 13.9661 17.5833 13.9661 16.6667C13.9661 15.75 14.2925 14.9653 14.9453 14.3125C15.5981 13.6597 16.3828 13.3333 17.2995 13.3333C18.2161 13.3333 19.0009 13.6597 19.6536 14.3125C20.3064 14.9653 20.6328 15.75 20.6328 16.6667C20.6328 17.5833 20.3064 18.3681 19.6536 19.0208C19.0009 19.6736 18.2161 20 17.2995 20ZM10.6328 26.6667V24.3333C10.6328 23.8611 10.7543 23.4271 10.9974 23.0313C11.2405 22.6354 11.5634 22.3333 11.9661 22.125C12.8273 21.6945 13.7023 21.3715 14.5911 21.1563C15.48 20.941 16.3828 20.8333 17.2995 20.8333C18.2161 20.8333 19.1189 20.941 20.0078 21.1563C20.8967 21.3715 21.7717 21.6945 22.6328 22.125C23.0356 22.3333 23.3585 22.6354 23.6016 23.0313C23.8446 23.4271 23.9661 23.8611 23.9661 24.3333V26.6667H10.6328Z",
					fill: "#064C68"
				})
			})]
		})]
	})
});
export default SvgCompletedSubject;
